import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { throttle } from 'underscore';
import HeaderView from './header_view';

const HeaderContainer = ({ loggedIn }) => {
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const checkScroll = throttle(() => {
      setScrolling(document.body.scrollTop > 5 || document.documentElement.scrollTop > 10);
    });

    document.addEventListener('scroll', checkScroll);

    return () => { document.removeEventListener('scroll', checkScroll); };
  }, []);

  useEffect(() => {
    document.body.classList[scrolling ? 'add' : 'remove']('site-is-scrolling');
  }, [scrolling]);

  const className = classnames('site-header', {
    'site-header--logged-in': loggedIn,
    'site-header--scrolling': scrolling,
  });

  const logoClassName = classnames('bvs-site-logo', {
    'bvs-site-logo_scrolling': scrolling,
  });

  return <HeaderView className={className} loggedIn={loggedIn} logoClassName={logoClassName} />;
};

HeaderContainer.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
};

export default HeaderContainer;
